export const regEx = {
  onlyNumber: /[0-9]/,
  numbersAndDot: /[0-9.]/,
  startsWithZero: /^0[0-9]/,
};
